export const environment = {
  appName: "HHEO",
  production: true,
  serverUrl: "https://apeco-gateway-dev.agreeablesand-58a49097.westeurope.azurecontainerapps.io",
  env: 'Quality Assurance',
  version: '5.0',
  defaultLang: 'en',
  appInsights: {
    instrumentationKey: "77b73c20-78b4-443e-b024-ef802cf2f6eb",
  },
};

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
